import gql from 'graphql-tag';

export default gql`
  mutation setDesignerOpinion(
    $designer: ID
    $opinion: Int
  ) {
    setUserOpinionDesigner(
      designer: $designer
      opinion: $opinion
    ) {
      designer {
        id
        firstName
      }
      opinion
    }
  }
`;
